/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentGroup
 */
export interface DocumentGroup {
    /**
     * 
     * @type {number}
     * @memberof DocumentGroup
     */
    documentGroupId: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentGroup
     */
    internalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGroup
     */
    mainDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGroup
     */
    tagsText?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGroup
     */
    documentGroupType: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGroup
     */
    reportType: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGroup
     */
    sharedTargetType?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentGroup
     */
    targetHealthProType?: string;
}

/**
 * Check if a given object implements the DocumentGroup interface.
 */
export function instanceOfDocumentGroup(value: object): value is DocumentGroup {
    if (!('documentGroupId' in value) || value['documentGroupId'] === undefined) return false;
    if (!('documentGroupType' in value) || value['documentGroupType'] === undefined) return false;
    if (!('reportType' in value) || value['reportType'] === undefined) return false;
    return true;
}

export function DocumentGroupFromJSON(json: any): DocumentGroup {
    return DocumentGroupFromJSONTyped(json, false);
}

export function DocumentGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'documentGroupId': json['documentGroupId'],
        'internalCode': json['internalCode'] == null ? undefined : json['internalCode'],
        'mainDescription': json['mainDescription'] == null ? undefined : json['mainDescription'],
        'tagsText': json['tagsText'] == null ? undefined : json['tagsText'],
        'documentGroupType': json['documentGroupType'],
        'reportType': json['reportType'],
        'sharedTargetType': json['sharedTargetType'] == null ? undefined : json['sharedTargetType'],
        'targetHealthProType': json['targetHealthProType'] == null ? undefined : json['targetHealthProType'],
    };
}

export function DocumentGroupToJSON(json: any): DocumentGroup {
    return DocumentGroupToJSONTyped(json, false);
}

export function DocumentGroupToJSONTyped(value?: DocumentGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentGroupId': value['documentGroupId'],
        'internalCode': value['internalCode'],
        'mainDescription': value['mainDescription'],
        'tagsText': value['tagsText'],
        'documentGroupType': value['documentGroupType'],
        'reportType': value['reportType'],
        'sharedTargetType': value['sharedTargetType'],
        'targetHealthProType': value['targetHealthProType'],
    };
}

